import { useDispatch, useSelector } from "react-redux";
import { useT } from '../../../../../../helpers/i18n';
import Checkers from "../../../../../../helpers/class/Checkers";
import LgConsts from "../../../../../../helpers/LgConsts";
import { enableBookingBtn, fetchBuilderSettingByKey } from "../../../../../../helpers/MethodHelper";
import { generateBookUrlHandler, generateIquiryUrlHandler } from "../../../../../../helpers/HandlerHelper";
import { setSearchbarEmptyFields, updateBookingFormTriggered } from "../../../../../../redux/actions";
import { useEffect, useState } from "react";

export default function BookingInquireChainButtons(props) {
  const t = useT();

  const dispatch = useDispatch()

  const showIquires = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_inquires_allow')
  );

  const { inquiriesActiveForSingleBedroom, hasOpenCalendar, isAvailable } = props

  const propertyInitialAvailability = useSelector(state => state['propertyAvailability']['initialAvailability'])
  const inquiriesOnly = useSelector(state => state['appSettings']['inquiriesOnly'])

  const bedroomPricing = useSelector(state => state['appSettings']['bedroomPricing'])

  const priceLoading = useSelector(state => state['appSettings']['priceLoading'])
  const adults = useSelector(state => state['propertiesParams']['adults'])
  const kids = useSelector(state => state['propertiesParams']['kids'])
  const infants = useSelector(state => state['propertiesParams']['infants'])

  const dateRangeValid = useSelector(state => state['propertiesParams']['dateRangeValid'])

  const personsForBooking = (adults + kids + infants)

  const inquiryUrl = generateIquiryUrlHandler()

  const bookUrl = generateBookUrlHandler()

  const enableButtons = enableBookingBtn(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid)

  const bookingType = useSelector(state => state['appSettings']['bookingType'])

  const [canInquire, setCanInquire] = useState(false)

  const [infoNeeded, setInfoNeeded] = useState(false)

  const isSuccess = useSelector(state => state['appSettings']['success']);

  let builder_booking_box_class = 'col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0';

  let builder_booking_box_border = false;
  let builder_booking_box_shadow = false;
  let builder_booking_box_radius = 0;

  const [showToast, setShowToast] = useState(false);
  const hasPrice = props.price

  let white_class = 'bg-master-lightest';
  if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
    white_class = 'bg-white';
  }

  const modifyRoomParam = (url, newRoomValue) => {
    const urlObj = new URL(url);
    urlObj.searchParams.set("room", newRoomValue);
    return urlObj.toString();
  };

  useEffect(() => {
    if (isSuccess) {
      setCanInquire(true);
    }
  }, [isSuccess, canInquire]);

  const emptyEntriesHandler = () => {

    if (isSuccess) {
      setInfoNeeded(true)
    }
    else {
      setInfoNeeded(false)
    }

    setShowToast(true)

    const el = document.getElementById("booking-search-bar")
    dispatch(setSearchbarEmptyFields(true))

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    }

    setTimeout(() => {
      setShowToast(false)
    }, 5000)
  }

  const isDisabled = (!canInquire || isAvailable == 0);

  const isDisabledForInquiry = (!canInquire || isAvailable == 0) && (!hasOpenCalendar);

  return (
    <div className={builder_booking_box_class}>
      <div className="row">
        {
          (inquiriesOnly == '1' || showIquires == '1' || bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES) ?
            <div className={"col"} onClick={(e) => {
              if (isDisabled) {
                e.preventDefault()
                emptyEntriesHandler()
                return
              }
              dispatch(updateBookingFormTriggered(true))
            }}>
              <a className={`btn btn-lg btn-default btn-black full-width btn-bordered ${isDisabledForInquiry ? 'disabled' : ''}`}
                target="_blank" rel="noreferrer" href={inquiryUrl}>{t('booking.inquire')}</a>
            </div>
            :
            ""
        }
        {
          !inquiriesActiveForSingleBedroom && inquiriesOnly != '1' && Checkers.isValidString(bookUrl) && (bookingType == LgConsts.BOOKING_TYPE_2_WEBHOTELIER || (propertyInitialAvailability && bookingType == LgConsts.BOOKING_TYPE_1_INQUIRIES)) ?
            <div className={"col"} onClick={(e) => {
              if (isDisabled) {
                e.preventDefault()
                emptyEntriesHandler()
                return
              }
              dispatch(updateBookingFormTriggered(true))
            }}>
              <a className={"btn btn-lg btn-primary btn-design-color full-width " + (!isDisabled ? '' : 'disabled')}
                target="_blank" rel="noreferrer" href={modifyRoomParam(bookUrl, `${props.whRoomCode}`)}>{t('booking.bookNow')}</a>
            </div>
            :
            <></>
        }
      </div>

      {showToast && (
        <div className="toast-container position-fixed bottom-0 start-0 p-3" style={{ zIndex: 999 }}>
          <div className="toast show align-items-center text-bg-danger border-0">
            <div className="d-flex">
              <div className="toast-body">
                {infoNeeded ? t('booking.noAvailabilityRange') : t('booking.selectDatesAndGuests')}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
              ></button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}